import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

const PRIMARY = '#1ABB9C';

/**
 * Mini gráfico de barras (ex: 7 dias da semana).
 * Props:
 * - data: [{ label, value, highlight? }]
 * - accent: cor das barras
 * - height: altura útil das barras em px
 */
export default function MiniBarChart({ data = [], accent = PRIMARY, height = 56 }) {
    const max = Math.max(1, ...data.map(d => d.value || 0));

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.75, height, mt: 0.5 }} role="img"
             aria-label={`Sessões por dia: ${data.map(d => `${d.label} ${d.value}`).join(', ')}`}>
            {data.map((d, i) => {
                const h = Math.round(((d.value || 0) / max) * (height - 16));
                return (
                    <Box key={i} sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title={`${d.label}: ${d.value}`} arrow>
                            <Box
                                sx={{
                                    width: '100%', minHeight: 3, height: Math.max(3, h), borderRadius: '4px 4px 0 0',
                                    bgcolor: d.highlight ? accent : accent + '55',
                                    transition: 'height 0.3s ease',
                                }}
                            />
                        </Tooltip>
                        <Typography variant="caption" sx={{ fontSize: '0.6rem', color: d.highlight ? accent : 'text.secondary', fontWeight: d.highlight ? 700 : 400 }}>
                            {d.label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
}
